export default (str) => {
  const url = `${window.facebookApiUrl}hash`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      body: str,
      headers: {
        'content-type': 'text/plain',
      },
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};
